import { createSlice } from "@reduxjs/toolkit";

const homeDashCalender = createSlice({
  name: "homeDashCalender",
  initialState: {
    isCalendarOpenR: false,
  },
  reducers: {
    toggleCalendar: (state, action) => {
      state.isCalendarOpenR = action.payload;
    },
  },
});

export const { toggleCalendar } = homeDashCalender.actions;

export default homeDashCalender.reducer;
